import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { HomePage } from './home.page';

import { HomePageRoutingModule } from './home-routing.module';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { TilesContainerComponent } from './components/tiles-container/tiles-container.component';
import { BaseTileComponent } from './components/base-tile/base-tile.component';
import { RecentOrderTileComponent } from './components/recent-order-tile/recent-order-tile.component';
import { InteractBannerComponent } from './components/interact-banner/interact-banner.component';
import { CustomMessageBannerComponent } from './components/custom-message-banner/custom-message-banner.component';
import { RebatesBannerComponent } from './components/rebates-banner/rebates-banner.component';
import { SharedProductModule } from '@app/shared-product/shared-product.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HomePageRoutingModule,
    TranslateModule,
    SharedModule,
    SharedProductModule,
  ],
  declarations: [
    HomePage,
    TilesContainerComponent,
    BaseTileComponent,
    RecentOrderTileComponent,
    InteractBannerComponent,
    CustomMessageBannerComponent,
    RebatesBannerComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomePageModule {}
